import React from "react";
import "./Footer.css"

function Footer() {
    return <footer className="footer">
        <div className="footer-images">
            Hosted by
            <div className="footer-logo-container">
                <img src="/tandon_long_white.png" alt="NYU Tandon Logo" className="footer-logo" />
                <p className="footer-logo-text">Dept. of Civil, Urban, &amp; Environmental Engineering</p>
            </div>
            <img src="/c2-white.png" alt="C2SMART logo" className="footer-logo" />
            <img src="/civil_environmental_engineering_unitmark_white.png" alt="Carnegie Mellon University Civil & Environmental Engineering" className="footer-logo cmu-footer-logo" />
        </div>
        <p>© {new Date().getFullYear()} C2SMART</p>
    </footer>
}

export default Footer;
